import * as React from 'react';
import classNames from 'classnames';

import * as styles from './locationFields.css';

export interface ILocationFieldsProps {
  published: boolean;
}
export const LocationFields = ({ children, published }: React.PropsWithChildren<ILocationFieldsProps>) => {
  return (
    <div className={classNames(styles['component'], !published && styles['component--unpublished'])}>{children}</div>
  );
};
